import * as ACTION_TYPES from '../types';

const initialState = {
  loading: false,
  error: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.LOGIN_REQUEST:
      return {
        ...state,
        loading: true
      };

    case ACTION_TYPES.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case ACTION_TYPES.LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: true
      };

    case ACTION_TYPES.REGISTER_REQUEST:
      return {
        ...state,
        loading: true
      };

    case ACTION_TYPES.REGISTER_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case ACTION_TYPES.REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        error: true
      };

      case ACTION_TYPES.VERIFY_REQUEST:
      return {
        ...state,
        loading: true
      };

    case ACTION_TYPES.VERIFY_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case ACTION_TYPES.VERIFY_FAIL:
      return {
        ...state,
        loading: false,
        error: true
      };

    default:
      return state;
  }
};
